import React from 'react';
import { STRINGS } from '../../constants';

const Loader: React.FC = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center w-full h-full 
                    bg-black/50 backdrop-blur-sm z-50 loader-overlay">

      <p className="mb-3 text-lg font-medium text-white">
        {STRINGS.xPlat.loading}
      </p>

      <div aria-hidden className="h-12 w-12 rounded-full">
        <svg 
          className="spin"
          width="40" 
          height="40" 
          viewBox="0 0 50 50" 
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g fill="none" fillRule="evenodd" strokeWidth="4">
            <circle cx="25" cy="25" r="20" strokeOpacity="0.3"/>
            <path d="M45 25a20 20 0 0 1-20 20" />
          </g>
        </svg>

       </div>
    </div>
  );
};

export default Loader;
